export function SkeletonForm() {
  return (
    <div className="card">
      <div className="skeleton" style={{ height: 12, width: '30%', marginBottom: 10 }}></div>
      <div className="skeleton" style={{ height: 38, width: '100%', marginBottom: 22 }}></div>
      <div className="skeleton" style={{ height: 12, width: '40%', marginBottom: 10 }}></div>
      <div className="skeleton" style={{ height: 84, width: '100%' }}></div>
    </div>
  );
}
